import React, { useEffect } from 'react';

import { userActions } from '../../actions';
import { history } from '../../helpers';

import { useParams } from 'react-router';
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import AsyncCreatableSelect from 'react-select/async-creatable';

function EditReservation() {
  const { id } = useParams();

  const dispatch = useDispatch();

  const isNew = id === 'nouveau';

  const changeAction = isNew ? userActions.setAddReservation : userActions.setEditReservation;
  const submitAction = isNew ? userActions.postReservation : userActions.patchReservation;

  const reservationsState = useSelector(state => state.reservations);
  const globalState = useSelector(state => state.global);

  let reservation = isNew ? reservationsState.add : reservationsState.edit;

  if (isNew && !reservation) {
    history.replace('/');
  }

  let selectValue = null;
  if (reservation) {
    const adversaire = reservation.clients[0];
    if (adversaire) {
      selectValue = adversaire.clientId ?
        { key: adversaire.clientId, label: adversaire.clientNom } : { key: 'externe', label: adversaire.externe };
    }
  }

  useEffect(() => {
    if (!reservationsState.items) {
      dispatch(userActions.getReservations());
    }

    if (!isNew) {
      dispatch(userActions.editReservation(id));
    }
  }, [dispatch, reservationsState.items, id, isNew]);

  function handleChange(e) {
    const { name, value } = e.target;

    const updateObject = { ...reservation, [name]: value };

    updateObject.fin = updateObject.debut + (updateObject.nbCreneau * globalState.config.creneau * 60);

    dispatch(changeAction(updateObject));
  }

  function handleChangeSelect(e) {
    const value = e ? (e.key ? [{ clientId: e.key, clientNom: e.label }] : [{ clientId: null, externe: e.label }]) : [];

    handleChange({ target: { name: 'clients', value } });
  }

  function handleSubmit(e) {
    e.preventDefault();

    dispatch(submitAction(reservation));
  }

  function handleInputChange(newValue) {
    return newValue;
  }

  const loadOptions = (inputValue, callback) => {
    if (!inputValue.trim()) {
      callback([]);
      return;
    }
    dispatch(userActions.searchClients(inputValue, callback));
  };

  return (
    <div className="bloc-reservation">
      <h2 className="bloc-reservation__title">
        <span className="bloc-reservation__icon">
          <svg className="icon" aria-hidden="true">
            <use xlinkHref="#icon-15-raquette" />
          </svg>
        </span>
        {isNew ? 'Ajouter une réservation' : 'Modification de ma réservation'}
      </h2>
      {reservation &&
        <form className="form form--resa-court clearfix" noValidate onSubmit={handleSubmit}>
          <div className="bloc-reservation__item no-hover">
            <div>
              <strong>{reservation.momentDebut.format('dddd DD MMMM')} </strong>
              <span className="bloc-reservation__date">
                  de <strong>{reservation.momentDebut.format('LT')} à {reservation.momentFin.format('LT')}</strong>
              </span>
              <span className="bloc-reservation__people">avec {reservation.people}</span>
            </div>
          </div>
          <div className="form__inner">
            <div className="form-group form-group__select">
              <label htmlFor="nbCreneau">Nombre de créneau</label>
              <select name="nbCreneau" id="nbCreneau" value={reservation.nbCreneau} onChange={handleChange}>
                <option value="1">1</option>
                <option value="2">2</option>
              </select>
              <div aria-hidden="true" className="custom-select__indicator custom-select__dropdown-indicator css-tlfecz-indicatorContainer">
                <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false">
                  <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
                </svg>
              </div>
            </div>
            <div className="form-group">
              <label htmlFor="client">Nom de mon adversaire</label>
              <AsyncCreatableSelect
                className="custom-select-container"
                classNamePrefix="custom-select"
                isClearable
                inputId="client"
                defaultValue={selectValue}
                onChange={handleChangeSelect}
                openMenuOnClick={false}
                placeholder='Rechercher un joueur...'
                loadingMessage={() => 'chargement...'}
                noOptionsMessage={() => 'Rechercher un joueur...'}
                formatCreateLabel={(inputValue) => `Ajouter ${inputValue} (externe)`}
                cacheOptions
                loadOptions={loadOptions}
                defaultOptions
                onInputChange={handleInputChange}
              />
            </div>
          </div>
          {reservation.canEdit &&
            <button className="btn btn--no-icon btn--submit" type="submit">
              {isNew ? 'Réserver' : 'Enregistrer'}
            </button>
          }
          <Link to={isNew ? "/reservation/planning" : "/"} className="btn btn--no-icon btn--light btn--submit">Retour</Link>
        </form>
      }
      {(!reservation && !globalState.loading) &&
        <p>Réservation invalide.</p>
      }
    </div>
  );
}

export default EditReservation;
